import React from 'react';
import About from '../components/About';

function AboutPage() {
  return <About />;
}

export default AboutPage;
